import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Navbar from './components/navbar/navbar.component';
import Home from './screens/Home';
import Register from './screens/Register';
import Login from './screens/Login';
import Shop from './screens/Shop'; // <-- import Shop page
import Dashboard from './screens/Dashboard'; // <-- updated import
import Cart from "./screens/Cart";
import Checkout from "./screens/Checkout";
import ProductDetails from "./screens/ProductDetails";
import PaymentSuccess from "./screens/PaymentSuccess";
import PaymentFailed from "./screens/PaymentFailed";
import VerifyOtp from "./screens/VerifyOtp";


const Routes = () => {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <ToastContainer />
      <Switch>
        <Route exact path='/' component={Home} />
        <Route exact path='/register' component={Register} />
        <Route exact path='/login' component={Login} />
         <Route exact path='/shop' component={Shop} /> {/* <-- add Shop route */}
         <Route exact path='/dashboard' component={Dashboard} /> {/* <-- updated route */}
         <Route  exact path='/cart' component={ Cart } />
         <Route path="/checkout" component={Checkout} />
         <Route path="/product/:id" component={ProductDetails} />
         <Route path="/payment-success" component={PaymentSuccess} />
          <Route path="/payment-failed" component={PaymentFailed} />
          <Route path="/verify-otp" component={VerifyOtp} />

      </Switch>
      </div>
    </BrowserRouter>
  );
};

export default Routes;
